import { Components } from '@mui/material/styles/components';
import { palette } from './palette';

export const components: Components = {
    MuiTableCell: {
        styleOverrides: {
            root: {
                fontFamily: 'Montserrat500',
            },
            sizeSmall: {
                fontSize: 14,
                lineHeight: 1.2,
                padding: '.5em 1em',
            },
            head: {
                color: palette.text.secondary,
                fontFamily: 'Montserrat400',
                lineHeight: 'inherit',
            },
        },
    },
};
